import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { createSequenceContacts } from 'redux/actions/sequenceContactActions';
import { getPreviewContacts } from 'redux/actions/contactActions';
import { getErrorMessage } from 'utils/misc';
import { validContacts, transformSequenceContacts } from 'utils/contact';
import ContactList from '../../../ContactList/ContactList';
import ContactStats from './ContactStats';
import SequenceBuilderActions from '../SequenceBuilderActions';


class ContactsReadyPage extends Component {
  static propTypes = {
    onSkip: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    modifyChoices: PropTypes.shape({
      active: PropTypes.bool,
      detail_page: PropTypes.bool,
      exlude_self: PropTypes.bool,
    }),
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      account_id: PropTypes.number,
      allow_duplicates: PropTypes.bool,
    }).isRequired,
    sequencePendingContacts: PropTypes.shape({
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      results: PropTypes.array,
      params: PropTypes.shape({}),
    }).isRequired,
    onBack: PropTypes.func.isRequired,
    createSequenceContacts: PropTypes.func.isRequired,
    getPreviewContacts: PropTypes.func.isRequired,
    sequenceBuilder: PropTypes.bool,
    handleChangeModalSize: PropTypes.func,
    onSubmit: PropTypes.func,
    toggleModal: PropTypes.func,
    sequenceContacts: PropTypes.shape({
      loading: PropTypes.bool,
    }).isRequired,
  };

  static defaultProps = {
    modifyChoices: {},
    sequenceBuilder: false,
    handleChangeModalSize: () => {},
    onSubmit: () => {},
    toggleModal: () => {},
  };

  componentDidMount() {
    // Get sequence preview contacts
    this.props.getPreviewContacts(this.props.sequencePendingContacts.params);
    this.props.handleChangeModalSize('extra-large');
  }

  addSequenceContacts = async (sequencePendingContacts) => {
    const { sequence } = this.props;
    try {
      await this.props.createSequenceContacts(transformSequenceContacts(sequencePendingContacts, sequence.id));
    } catch (error) {
      this.showNotification(getErrorMessage(error));
    }
  }

  processSubmit = async (next) => {
    const { onSubmit, sequencePendingContacts } = this.props;
    await this.addSequenceContacts(validContacts(sequencePendingContacts.results));
    if (next) {
      this.props.onNext();
    } else {
      onSubmit();
    }
  }

  render() {
    const {
      sequencePendingContacts, sequence,
      onSkip, onBack, sequenceBuilder,
      toggleModal,
    } = this.props;

    const isLoading = sequencePendingContacts.loading || sequence.loading;

    return (
      <form className="sequence-create__contacts-ready" onSubmit={e => e.preventDefault()}>
        {isLoading && <div className="loader"><LoadingIcon /></div>}

        {!isLoading &&
          <ContactStats
            validContacts={sequencePendingContacts.total_valid_contacts}
            contacts={sequencePendingContacts.results}
          />
        }
        <div className="instance-form__body">
          <ContactList
            sequence={sequence}
            validContacts={sequencePendingContacts.total_valid_contacts}
            contacts={sequencePendingContacts}
          />
        </div>

        {sequenceBuilder ?
          <SequenceBuilderActions
            onBack={onBack}
            onSkip={onSkip}
            onNext={() => this.processSubmit(true)}
            onSave={() => this.processSubmit(false)}
            isLoading={this.props.sequenceContacts.loading}
          /> :
          <SequenceBuilderActions
            onBack={onBack}
            onNext={() => this.processSubmit(false)}
            saveBtnText="Cancel"
            onSave={toggleModal}
            nextBtnText={`Add ${sequencePendingContacts.total_valid_contacts} Contacts`}
            isLoading={this.props.sequenceContacts.loading}
          />
        }
      </form>
    );
  }
}


export default compose(
  connect(
    state => ({
      sequence: state.sequence,
      sequenceContacts: state.sequenceContacts,
      sequencePendingContacts: state.previewContacts,
    }),
    { getPreviewContacts, createSequenceContacts },
  ),
  reduxForm({
    form: 'sequenceImportTemplateReadyForm',
  }),
)(ContactsReadyPage);
